import { gqlClient } from '@/api/graphql-client';
import projectKeys from '@/api/queries/project/keyFactory';
import { graphql } from '@/gql';
import {
  MarkGrantAsPaidInput,
  MarkGrantAsPaidMutation as MarkGrantAsPaidMutationResult,
} from '@/gql/graphql';
import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

const MarkGrantAsPaidMutation = graphql(`
  mutation MarkGrantAsPaid($input: MarkGrantAsPaidInput!) {
    markGrantAsPaid(input: $input) {
      id
      paidAt
    }
  }
`);

const useMarkGrantAsPaid = (args: {
  projectId: string;
  options?: UseMutationOptions<
    MarkGrantAsPaidMutationResult,
    Error,
    MarkGrantAsPaidInput
  >;
}) => {
  const { projectId } = args;
  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = args.options ?? {};

  return useMutation<
    MarkGrantAsPaidMutationResult,
    Error,
    MarkGrantAsPaidInput
  >({
    mutationFn: (input) =>
      gqlClient.request(MarkGrantAsPaidMutation, { input }),
    onSuccess: (data, variables, context) => {
      void queryClient.invalidateQueries({
        queryKey: projectKeys.project(projectId),
      });
      onSuccess?.(data, variables, context);
    },
    ...restOptions,
  });
};

export default useMarkGrantAsPaid;
